import { LoadingIndicator } from '@components';
import { plans } from '@utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { CardHome } from '../../common/components/CardsHome';

export const HomePage = () => {
  const user = useSelector((state) => state.user);
  const loading = useSelector((state) => state.loading.show);

  return (user.id !== user.matricula && !loading) ||
    user.id === user.matricula ? (
    <>
      <Helmet>
        <title>Forluz - Home</title>
      </Helmet>
      <div className="d-none d-md-block mb-5 mt-0">
        <span className="text-muted ts-24 ">
          <strong>Olá, {user.nome}.&nbsp;</strong>O que você precisa hoje?
        </span>
        <br />
        <span className="text-muted ts-20 ">
          <strong>Plano {plans[user.plano]}&nbsp;</strong>
          {user.patrocinadora}
        </span>
      </div>
      <div className="d-block d-md-none text-muted ts-20 mb-5">
        <span className="text-muted ts-24 ">
          <strong>Olá, {user.nome}.&nbsp;</strong>O que você precisa hoje?
        </span>
        <br />
        <span className="text-muted ts-20 ">
          <strong>Plano {plans[user.plano]}&nbsp;</strong>
          {user.patrocinadora}
        </span>
      </div>
      <CardHome isHomePage />
    </>
  ) : (
    <LoadingIndicator />
  );
};
